import * as React from "react";
import { NavButton } from "kw/components/NavButton/NavButton";
import { Button } from "kanopi-components/Button";

// TODO: Have Button make its own props known
type TButtonProps = React.ComponentProps<typeof Button>;

export const NextButton = (props: TButtonProps) => (
  <NavButton type="submit" arrow {...props}>
    {"Next"}
  </NavButton>
);
